import { type NavigationAnchor } from "@/components/layout/types";

import {
  Module,
  PATH_AGREEMENTS,
  PATH_CONTEST_AGREEMENTS,
  PATH_CONTRACTORS_STUDENTS,
  PATH_DICTS_AGREEMENT_COMPANIES,
  PATH_DICTS_AGREEMENT_TYPES,
} from "@/constants";
import { usePermissions } from "@/modules/account/hooks/usePermissions";
import { useTranslation } from "react-i18next";
import { Building2, FileText, GraduationCap, Tags } from "lucide-react";

export const useAgreementManagementItems = (): NavigationAnchor[] => {
  const { t } = useTranslation();
  const permissions = usePermissions();

  return [
    {
      icon: FileText,
      url: PATH_AGREEMENTS,
      permission: permissions[Module.Agreements].can_read,
      title: t("navigation.agreements"),
    },
    {
      icon: FileText,
      url: PATH_CONTEST_AGREEMENTS,
      permission: permissions[Module.ContestAgreements].can_read,
      title: t("navigation.contestAgreements"),
    },
    {
      icon: GraduationCap,
      url: PATH_CONTRACTORS_STUDENTS,
      permission: permissions[Module.ContractorStudents].can_read,
      title: t("navigation.students"),
    },
    {
      icon: Tags,
      url: PATH_DICTS_AGREEMENT_TYPES,
      permission: permissions[Module.AgreementTypes].can_read,
      title: t("navigation.agreementTypes"),
    },
    {
      icon: Building2,
      url: PATH_DICTS_AGREEMENT_COMPANIES,
      permission: permissions[Module.AgreementCompanies].can_read,
      title: t("navigation.agreementCompanies"),
    },
  ];
};
